iScreenWizard.factory('nieuwGroepsprofielService', function ($state, $rootScope) {

    var service = {

        model: {

        },

        SaveState: function () {
            localStorage.nieuwe360FeedbackService = angular.toJson(service.model);
        },

        RestoreState: function () {
            if (typeof localStorage.nieuwe360FeedbackService !== 'undefined') {
                service.model = angular.fromJson(localStorage.nieuwe360FeedbackService);
            }
        }
    };

    $rootScope.$on("savestate", service.SaveState);
    $rootScope.$on("restorestate", service.RestoreState);

    service.RestoreState();

    return service;
});